import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { Button } from 'antd-mobile'
import * as styles from './style/index.scss'
import ActiveBg from '@assets/img/global/bj_activate.png'
import { FormattedMessage } from 'react-intl'
import { filterFlowUnit, formatPackageTimeLength } from '@src/utils';
import intl from '@utils/intl';
import { getLang } from '@src/utils'
import { userStore } from '@src/store/userStore'
import { TRYBUY_EVENT_TRACING_CLICK } from '@src/constants'
interface ActivePackageProps {
    dto: any
    operatorsId: any
    handleActive: () => void
}

class ActivePackage extends ComponentExt<ActivePackageProps> {
    constructor(props) {
        super(props)
    }

    formatPackageContent = (dto) => {
        const tableApp = localStorage.getItem('chl') === 'tabletApp'
        const { policyDegree, goodsNumber, timeLength, timeUnit } = dto
        const obj = formatPackageTimeLength({ timeLength, timeUnit })
        const oddMessageId = obj.timeUnit === '0' ? 'common.unitMonthOdd' : 'common.unitDayOdd'
        const pluralMessageId = obj.timeUnit === '0' ? 'common.unitMonthPlural' : 'common.unitDayPlural'
        const totalTimeLength = goodsNumber * obj.timeLength
        // const currentDate = new Date().getDate();
        // const currentMonth = new Date().getMonth() + 1;
        // if ((this.props.operatorsId == 6) && ((currentMonth == 11 && currentDate >= 15) || currentMonth == 12 || (currentMonth == 1 && currentDate <= 15))) {
        //     return `1GB * 6${intl.formatMessage({ id: 'common.unitMonthPlural' })}+5GB * 3${intl.formatMessage({ id: 'common.unitMonthPlural' })} `
        // } else {
        //     return `${filterFlowUnit(Number(policyDegree))} * ${totalTimeLength}${intl.formatMessage({ id: totalTimeLength > 1 ? pluralMessageId : oddMessageId })} ${tableApp ? '(' + intl.formatMessage({ id: 'common.infiniteAct' }) + ')' : ''}`
        // }

        return `${filterFlowUnit(Number(policyDegree))} * ${totalTimeLength}${intl.formatMessage({ id: totalTimeLength > 1 ? pluralMessageId : oddMessageId })}`
    }

    formatValidDate = (dto) => {
        const { goodsNumber, timeLength, timeUnit } = dto
        if (timeUnit === '0') {
            return `${Number(goodsNumber) * Number(timeLength)} ${intl.formatMessage({ id: goodsNumber === 1 ? 'common.unitMonthOdd' : 'common.unitMonthPlural' })}`
        } else {
            return `${Number(goodsNumber) * Number(timeLength)} ${intl.formatMessage({ id: timeLength === 1 && goodsNumber === 1 ? 'common.unitDayOdd' : 'common.unitDayPlural' })}`
        }
    }
    handleActive = () => {
        this.props.handleActive()
        userStore.sendEventTracing({
            pageCode: '',
            buttonCode: TRYBUY_EVENT_TRACING_CLICK.TRYBUY_ACTIVE_PACKAGE,
            buttonInfo: ''
        })
    }
    render() {
        if (JSON.stringify(this.props.dto) === '{}') {
            return <></>
        }
        return (
            <div className={styles.activeWrap}>
                <img src={ActiveBg} className={styles.activeBg} />
                <section className={styles.activeInfoWrap}>
                    <h3>
                        <FormattedMessage id="home.active.title" />
                    </h3>
                    <p>
                        {this.props.operatorsId == 20 ? getLang() === 'it' ? <>
                            {`Il piano dati gratuito '${this.formatPackageContent(this.props.dto)}' è attivo immediatamente dopo l'attivazione e valido per 90 giorni. Attivo ora`}
                        </> : <>
                            {`The '${this.formatPackageContent(this.props.dto)}' free data is active immediately upon activation and valid for 90 days. Active Now`}
                        </> :
                            <FormattedMessage
                                id="home.active.intro"
                                values={{
                                    packageContent: this.formatPackageContent(this.props.dto),
                                    timeLength: this.formatValidDate(this.props.dto)
                                }}
                            />
                        }
                    </p>
                    {this.props.operatorsId != 20 &&
                        <div style={{ width: '100%', color: '#fff', marginTop: 20 }}>
                            {localStorage.getItem('chl') === 'tabletApp' ?
                                <FormattedMessage
                                    id="home.active.agreeForTablet"
                                    values={{
                                        a: chunks => <a style={{ color: '#FEF580' }} onClick={() => this.goToPath('/global/active-detail')}>{chunks}</a>,
                                        a1: chunks => <a style={{ color: '#FEF580' }} onClick={() => window.open('https://www.ckh.com.hk/en/global/tnc.php')}>{chunks}</a>,
                                        a2: chunks => <a style={{ color: '#FEF580' }} onClick={() => window.open('https://www.ckh.com.hk/en/global/privacy.php')}>{chunks}</a>,
                                    }}
                                />
                                :
                                <FormattedMessage
                                    id="home.active.agree"
                                    values={{
                                        a: chunks => <a style={{ color: '#FEF580' }} onClick={() => this.goToPath('/global/active-detail')}>{chunks}</a>,
                                        a1: chunks => <a style={{ color: '#FEF580' }} onClick={() => window.open('https://www.truphone.com/legal/truphone-esim-terms-and-conditions/')}>{chunks}</a>,
                                        a2: chunks => <a style={{ color: '#FEF580' }} onClick={() => window.open('https://www.truphone.com/legal/privacy-policy/')}>{chunks}</a>,
                                    }}
                                />
                            }
                        </div>}

                    <Button
                        className={styles.activeBtn}
                        onClick={this.handleActive}
                    >
                        <FormattedMessage id="home.active.btnText" />
                    </Button>
                </section>
            </div>
        )
    }
}

export default ActivePackage
